var render = function (_h,_vm) {var _c=_vm._c;return _c('div',_vm._g({ref:_vm.data.ref,staticClass:"h-100 d-flex flex-column"},_vm.listeners),[_vm._t("header"),_c('div',{staticClass:"flex-grow-1",class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle])},[_vm._t("default")],2),_vm._t("footer")],2)}
var staticRenderFns = []

export { render, staticRenderFns }